import { render, staticRenderFns } from "./SearchProjection.vue?vue&type=template&id=7dfd68ae"
import script from "./SearchProjection.vue?vue&type=script&lang=js"
export * from "./SearchProjection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports